import { AuthContext } from "providers/AuthProvider";
import { useContext, useState } from "react";
import { Auth } from "aws-amplify";
import { Toast } from "utility/helpers";

const useAuth = () => {
  const context = useContext(AuthContext);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const signIn = (email, password) => {
    setIsLoggingIn(true);
    localStorage.clear();

    return Auth.signIn(email, password).catch((ex) => {
      Toast({
        type: 4,
        content: ex?.message,
      });
    });
  };

  const changePassword = (newPassword) => {
    setIsLoggingIn(true);

    return Auth.completeNewPassword(newPassword).catch((ex) => {
      setIsLoggingIn(false);

      Toast({
        type: 4,
        content: ex?.message,
      });
    });
  };

  const hasPermission = (action) => {
    return context.permissions?.includes(action);
  };

  return {
    ...context,
    signIn,
    isLoggingIn,
    setIsLoggingIn,
    changePassword,
    hasPermission,
  };
};

export default useAuth;
